export enum SymptomTicketUrgency {
  NurseReview = 0,
  AttentionToday = 1,
  ImmediateAttention = 2
}

export enum SymptomTicketUrgencyText {
  NurseReview = 'Nurse Review',
  AttentionToday = 'Attention Today',
  ImmediateAttention = 'Immediate Attention'
}

export enum OperatorTicketUrgency {
  Standard = 0,
  High = 1
}

export enum OperatorTicketUrgencyText {
  Standard = 'Standard',
  High = 'High'
}

export enum AlertUrgency {
  Alert = 'Alert',
  UrgentAlert = 'UrgentAlert',
  CriticalAlert = 'CriticalAlert'
}

export enum AlertAttention {
  NurseReview = 2,
  AttentionToday = 3,
  ImmediateAttention = 4
}
